// extracted by mini-css-extract-plugin
export default {"products":"products--xbvLE","products-inner":"products-inner--JbIob"};